import React, { useMemo, useState } from 'react'
import styles from './escalationMetric.module.css';
import { EscalationTag } from './components/escalationTag/escalationTag.index';
import { Box, Divider } from '@mui/material';
import FilterIcon from '../../../../../../Components/Icons/filterIcon';
import { EscalationFilterPopup } from './components/escalationFilterPopup/escalationFilterPopup.index';
import { EscalationFilters } from '../../../../../../Models/escalatedPageModels';
import { useEscalationInfo } from '../../../../../../Context/escalationContext';
import { countActiveFilters } from '../../escalatedPageHeader.utils';
import { STATUS_COLORS } from '../../../../escalatedPage.constants';

interface EscalationMetricProps {
  appliedFilters: EscalationFilters;
  setAppliedFilters: (filters: EscalationFilters) => void;  
}

export const  EscalationMetric = (props: EscalationMetricProps) => {
  const { appliedFilters, setAppliedFilters } = props;
  const { totalEscalationsCount, escalationStatusesCount } = useEscalationInfo();
  const [isFilterPopupOpen, setIsFilterPopupOpen] = useState(false);

  const filterCount = useMemo(() => countActiveFilters(appliedFilters), [appliedFilters]);

  const handleFilterPopupOpen = () => {
    setIsFilterPopupOpen(true);
  }
  const handleFilterPopupClose = () => {
    setIsFilterPopupOpen(false);
  }
  return (
    <div className={styles.escalationMetricCtn}>
      <div className={styles.escalationMetricLeft}>
        <span className={styles.escalationMetricLeftTitle}>Total Escalations: {totalEscalationsCount}</span>
      </div>
      <Divider orientation='vertical' flexItem className={styles.escalationMetricDivider} />
      <div className={styles.escalationMetricMiddle}>
        {escalationStatusesCount.map((status, index) => (
          <>
            <EscalationTag key={status.id} label={status.status ?? 'Status'} value={status.applicationsCount ?? '0'} color={STATUS_COLORS[status.status.toLowerCase() as keyof typeof STATUS_COLORS]} />
            { index < escalationStatusesCount.length - 1 && ( <span className={styles.dotSeparator} /> )}
          </>
        ))}
      </div>
      <Divider orientation='vertical' flexItem className={styles.escalationMetricDivider} />
      <div className={styles.escalationMetricRight}>
        <Box className={styles.filterContainer} onClick={handleFilterPopupOpen}>
          <FilterIcon />
          {(filterCount > 0) && (
            <span className={styles.filterBadge}>{filterCount}</span>
          )}
        </Box>
      </div>
      {isFilterPopupOpen && <EscalationFilterPopup isOpen={isFilterPopupOpen} onClose={handleFilterPopupClose} appliedFilters={appliedFilters} setAppliedFilters={setAppliedFilters} />}
    </div>
  )
}
